import {
	hasProperty
} from '@/utils/index'
const supplier= {
	state: {
		info: {
			id: 0,
			value: ''
		}
	},
	mutations: {
		SET_SUPPLIER: (state: any, val: any) => {
			if(hasProperty(val, "id")) {
				state.info.id = val.id;
			}
			if(hasProperty(val, "value")) {
				state.info.value = val.value;
			}
		}
	},
	actions: {
		storeSupplier({commit}: any, data: any) {
			commit('SET_SUPPLIER', data);
		}
	}
}
export default supplier;
